import { Component, Renderer2 } from '@angular/core';
import { Router } from "@angular/router";
import { LocalStorageService } from './shared/services/storage/local-storage.service';
import { ToasterService, ToasterConfig } from 'angular2-toaster';
import { WebServiceService } from './shared/services/web-service.service';
import { Observable} from 'rxjs';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { of} from 'rxjs/observable/of';
import { merge} from 'rxjs/observable/merge';
import { mapTo } from 'rxjs/operators';
import { environment } from './../environments/environment';
import { TabTrackingService } from './shared/services/tab-tracking.service';
import { CheckActivityService } from './shared/services/check-activity.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [WebServiceService, LocalStorageService, TabTrackingService]
})

export class AppComponent {
  public toastConfig: ToasterConfig = new ToasterConfig({
  positionClass: 'toast-top-right',
  animation: 'fade',
  showCloseButton: true,
  limit: 1
  });
  notificationList: any = {};
  notificationLength: any = 0;
  online$: Observable<boolean>;
  public OnlineStatus: boolean=false;
  constructor(
  public _localStorageService: LocalStorageService,
  private router: Router,
  public webService: WebServiceService,
  private toasterService: ToasterService,
  private renderer: Renderer2,
  private tabTrackingService: TabTrackingService,
  private checkActivityService: CheckActivityService,
  ) {
    this.online$ = merge(
      of(navigator.onLine),
      fromEvent(window, 'online').pipe(mapTo(true)),
      fromEvent(window, 'offline').pipe(mapTo(false))
    )
   // this.networkStatus();
    this.isOnline();
    this.checkBrowser();
  }
  ngOnInit() {
    // this.getNotification();
    if (!environment.production) {
      this.addNoIndexNoFollowMetaTag();
    }
  }
  public networkStatus() {
    this.online$.subscribe(value => {
      this.OnlineStatus =value;
      if(!value)
      {
        this.toasterService.pop("error","Error","You are offline");
      }
    })
  }
  getNotification() {
  this.notificationList = [];
  let requestObj = {
    "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
    "userid": this._localStorageService.getUserId() ? this._localStorageService.getUserId() : 0,
    "page_no": "0",
    "record_per_page":'10',
  }
  this.webService.commonPostMethod('/notification_employee/ajax_getallnotification', requestObj).
    subscribe(
    data => {
      let list: any = data
      if (list.status) {
      let t: any = [];
      t = list.response;
      if (t) {
        for (let i of t) {
        if (i.read_indicator == "1") {
          let temp = {
          "company_id": null,
          "date_added": i.date_added,
          "date_updated": i.date_updated,
          "delete_indicator": i.delete_indicator,
          "from_id": i.from_id,
          "id": i.id,
          "message": i.message,
          "read_indicator": i.read_indicator,
          "reference_id": i.reference_id,
          "status": i.status,
          "target": i.target,
          "title": i.title,
          "to_id": i.to_id,
          };
          this.notificationList.push(temp)
        }
        }
      }
      }
    }, error => {
    }
    );
  }
  isOnline() {
    setTimeout(() => {
      this.networkStatus();
    }, 200);
  }
  checkBrowser()
  {

    window.addEventListener('storage', () => {
      console.log('another window or tab is working on the same localStorage')
      // window.alert('another window or tab is working on the same localStorage')
    }, false)

    // localStorage.setItem('Sentinel',Math.random().toString())
  }
  addNoIndexNoFollowMetaTag(): void {
    const meta = this.renderer.createElement('meta');
    this.renderer.setAttribute(meta, 'name', 'robots');
    this.renderer.setAttribute(meta, 'content', 'noindex, nofollow');
    this.renderer.appendChild(document.head, meta);
  }
  get showChatbot() {
    const url = this.router.url;
    return !(url.startsWith('/login') || url.startsWith('/my-companies'));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src872229562/src/src/app/app.component.ts